import React, { useState, useEffect } from "react";
import TextInput from "../library/TextInput";
import PaginatedTable from "../library/Pagination";
import API_BASE_URL from "../../config/api";

const EmergencyContacts = ({ userId }) => {
  const [rows, setRows] = useState([]);
  const [notification, setNotification] = useState(null);
  const [generalMaster, setGeneralMaster] = useState([]);


  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, []);

  const fetchData = () => {
    fetch(`${API_BASE_URL}/api/EmergencyContacts/employee/${userId}`)
      .then((res) => res.json())
      .then(setRows)
      .catch(console.error);
  };

  useEffect(fetchData, [userId]);

  const handleCloseNotification = () => setNotification(null);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const handleEditToggle = async (index) => {
    const updated = [...rows];
    const row = updated[index];

    if (!row.isEditing) {
      updated[index].isEditing = true;
      setRows(updated);
      return;
    }

    if (!row.name?.trim() || !row.relationship?.trim() || !row.address?.trim() || !row.contactNumber?.trim()) {
      setNotification({
        type: "error",
        message: "Please fill in all fields before saving.",
      });
      return;
    }

    if (!validatePhoneNumber(row.contactNumber)) {
      setNotification({
        type: "error",
        message: "Please enter a valid Phone Number.",
      });
      return;
    }
    handleCloseNotification();

    const method = row.id ? "PUT" : "POST";
    const url = row.id
      ? `${API_BASE_URL}/api/EmergencyContacts/${row.id}`
      : `${API_BASE_URL}/api/EmergencyContacts`;

    row.employeeId = userId;

    if (row.isEditing) {
      const payload = {
        id: row.id,
        name: row.name,
        relationship: row.relationship,
        address: row.address,
        contactNumber: row.contactNumber,
        employeeId: userId
      };

      var respones = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!respones.ok) {
        setNotification({
          type: "error",
          message: `Failed to ${method === "POST" ? "add" : "update"} contact.`,
        });
      }
    }

    updated[index].isEditing = !updated[index].isEditing;
    setRows(updated);
    fetchData();
  };

  const validatePhoneNumber = (number) => /^\d{8,14}$/.test(number);


  const handleDelete = async (index) => {
    const row = rows[index];
    if (row.id)
      await fetch(`${API_BASE_URL}/api/EmergencyContacts/${row.id}`, {
        method: "DELETE",
      });
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        name: "",
        relationship: "Parent",
        address: "",
        contactNumber: "",
        employeeId: userId,
        isEditing: true,
      },
    ]);
  };

  return (
    <div className="p-4">
      <h2 className="text-[#111518] text-[22px] font-bold leading-tight tracking-[-0.015em] pb-3">
        Emergency Contacts
      </h2>
      {notification && (
        <div
          className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
            }`}
        >
          <span>{notification.message}</span>
          <button
            onClick={handleCloseNotification}
            className="ml-4 font-bold text-lg leading-none"
          >
            ×
          </button>
        </div>
      )}


      <div className="px-4 py-3">
        <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
          <PaginatedTable
            columns={[
              "Name",
              "Relationship",
              "Address",
              "Contact Number",
              "Action",
            ]}
            data={rows}
            pageSize={10}
            showPagination={false}
            renderRow={(row, index) => (
              <tr key={row.id || index} className="border-t border-t-[#dde1e3]">
                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <TextInput
                    value={row.name}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) => handleChange(index, "name", e.target.value)}
                  />
                </td>
                <td className="h-[72px] px-4 py-2 text-[#121516] text-sm font-normal leading-normal">
                  <select
                    value={row.relationship}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "relationship", e.target.value)
                    }
                  >
                    {generalMaster.filter(x => x.mainId == 68).map((opt) => (
                      <option key={opt.id} value={opt.id}>{opt.title}</option>
                    ))}
                  </select>
                </td>
                <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-normal leading-normal">
                  <TextInput
                    value={row.address}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) => handleChange(index, "address", e.target.value)}
                  />
                </td>

                <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-bold leading-normal tracking-[0.015em]">
                  <TextInput
                    value={row.contactNumber}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "contactNumber", e.target.value)
                    }
                  />
                </td>

                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <div className="flex gap-2">
                    <button
                      className="text-blue-600"
                      onClick={() => handleEditToggle(index)}
                    >
                      {row.isEditing ? "Save" : "Edit"}
                    </button>
                    <button
                      className="text-red-600"
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </button>
                  </div>
                </td>

              </tr>
            )}
          />

        </div>
      </div>

      <div className="col-span-5 flex justify-end">
        <button
          className="btn-black"
          onClick={handleAddRow}
        >
          + Add Row
        </button>
      </div>


    </div>
  );
};

export default EmergencyContacts;
